import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { Endpoint } from "../shared/endpoints";
import { environment } from "src/environments/environment";

export interface FlowChatTurn {
  role: string;
  content: string;
}

export interface FlowChatRequest {
  message: string;
  history?: FlowChatTurn[];
  rawFlowDataJson?: string;
  flowRowKey?: string;
  sessionId?: string;
  /** URLs of supporting documents — the API fetches and extracts text from these server-side. */
  documentUrls?: string[];
}

export interface FlowChatCitation {
  title?: string | null;
  rowKey?: string | null;
  uniqueId?: string | null;
  url?: string | null;
}

export interface FlowChatResponse {
  answer: string;
  citations: FlowChatCitation[];
}

export interface FlowChatHistoryResponse {
  history: FlowChatTurn[];
}

@Injectable({
  providedIn: "root",
})
export class FlowAssistantChatService {
  constructor(private http: HttpClient) {}

  ask(request: FlowChatRequest): Observable<FlowChatResponse> {
    const headers = new HttpHeaders({
      Accept: "application/json",
      "Content-Type": "application/json",
    });
    return this.http.post<FlowChatResponse>(
      environment.apiBaseUrl + Endpoint.flowChatAskUrl,
      request,
      { headers }
    );
  }

  getHistory(flowRowKey?: string, sessionId?: string): Observable<FlowChatHistoryResponse> {
    const params = new URLSearchParams();
    if (flowRowKey) params.set("flowRowKey", flowRowKey);
    if (sessionId) params.set("sessionId", sessionId);
    const query = params.toString();
    const url =
      environment.apiBaseUrl +
      Endpoint.flowChatHistoryUrl +
      (query ? `?${query}` : "");
    return this.http.get<FlowChatHistoryResponse>(url);
  }

  clearHistory(flowRowKey?: string, sessionId?: string): Observable<void> {
    const params = new URLSearchParams();
    if (flowRowKey) params.set("flowRowKey", flowRowKey);
    if (sessionId) params.set("sessionId", sessionId);
    const query = params.toString();
    const url =
      environment.apiBaseUrl +
      Endpoint.flowChatHistoryUrl +
      (query ? `?${query}` : "");
    return this.http.delete<void>(url);
  }
}
